var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 28.181 28.181"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".carIcon_svg__a{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "carIcon_svg__a",
    d: "M0 0h28.181v28.181H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.217 7.057a1.754 1.754 0 00-1.668-1.186H7.633a1.766 1.766 0 00-1.668 1.186l-2.313 6.658a2.438 2.438 0 00-.129.775v8.407a1.762 1.762 0 003.523 0v-.587h14.09v.587a1.762 1.762 0 003.523 0V14.49a2.494 2.494 0 00-.129-.775zM7.633 18.787a1.761 1.761 0 111.761-1.761 1.759 1.759 0 01-1.761 1.761zm12.916 0a1.761 1.761 0 111.761-1.761 1.759 1.759 0 01-1.761 1.761zM5.871 12.916l1.492-4.485a1.19 1.19 0 011.116-.8h11.225a1.19 1.19 0 011.116.8l1.491 4.486z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "carIcon_svg__a",
    d: "M18.396 0h9.785v9.785h-9.785z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.288.815a4.077 4.077 0 104.077 4.077A4.079 4.079 0 0023.288.815zm0 6.116a.409.409 0 01-.408-.408V4.892a.408.408 0 01.815 0v1.631a.409.409 0 01-.407.408zm.408-3.262h-.816v-.815h.815z"
  })));
}

export default SvgCarIcon;